module.exports = __webpack_public_path__ + "a5929687753df1fb952529df01b6d7b3.TTF";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/EUROCAPS.TTF
// module id = 723
// module chunks = 0